import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import CancellationDeathNotificationShared from 'shell/components/shared/research-notifications/research-death/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface CancellationDeathNotificationCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const CancellationDeathNotificationCivilStatusShared = ({
  scope,
  items,
}: CancellationDeathNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  return (
    <Fragment>
      <CancellationDeathNotificationShared
        goBackUrl={goBackUrl}
        items={items}
        goBackUrlDetail={goBackUrlDetail}
      />
    </Fragment>
  );
};

CancellationDeathNotificationCivilStatusShared.displayName =
  'Cancellation Death Notification Page component';

export default CancellationDeathNotificationCivilStatusShared;
